import { useEffect, useState } from 'react'
import { useGetFamilyEvents } from 'api/family/family'
import Spinner from 'components/Spinner'
import { Empty, Pagination } from 'antd'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
import EventCard from 'components/Events/Views/CardView/SingleCard'
const Events = ({ familyId }: any) => {
  const [params, setParams] = useState({
    page: undefined,
    limit: undefined,
  })
  const { updateRouteParams } = useSyncParamsWithRoute(params, setParams)
  const PaginationChanger = (pagenumber: number, limit: number) => {
    updateRouteParams({ page: pagenumber, limit: limit })
  }
  const { data, isLoading, isFetching, refetch } = useGetFamilyEvents(
    familyId,
    params,
  )
  useEffect(() => {
    if (params.page) {
      refetch()
    }
  }, [params])

  return (
    <div className="bg-grey  padding-top-10">
      <div className="bg-white p-30px">
        {isFetching || isLoading ? (
          <div className="bg-white flex justify-center align-center">
            <Spinner />
          </div>
        ) : data?.records?.length ? (
          <>
            {data.records.map((event: any) => {
              return <EventCard event={event} key={event._id} />
            })}
            <div className="mb-20px mt-20px">
              {(data?.hasNextPage || data?.hasPrevPage) && (
                <div className="text-right">
                  <Pagination
                    onChange={PaginationChanger}
                    defaultCurrent={params.page}
                    total={data.count}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                    pageSize={params.limit || 10}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="flex justify-center align-center py-40">
            <Empty />
          </div>
        )}
      </div>
    </div>
  )
}
export default Events
